import { render, staticRenderFns } from "./ReplicaManagement.vue?vue&type=template&id=6b4c5e63"
import script from "./ReplicaManagement.vue?vue&type=script&lang=js"
export * from "./ReplicaManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports